import OldCMApp from '../apps/soccer/OldCm/OldCMApp'
import React from 'react'

const OldCMView = () => {
  return (
    <OldCMApp />
  )
}

export default OldCMView